var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Checkbox_2",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#7956D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1202 7.3526C18.6158 7.83318 18.628 8.62454 18.1474 9.12016L11.3599 16.1202C11.1243 16.3631 10.8003 16.5002 10.4619 16.5C10.1235 16.4998 9.79965 16.3625 9.5643 16.1193L6.3518 12.8001C5.87168 12.3041 5.88461 11.5127 6.38067 11.0326C6.87673 10.5525 7.66808 10.5654 8.1482 11.0615L10.4633 13.4535L16.3526 7.37984C16.8332 6.88422 17.6245 6.87203 18.1202 7.3526Z",
    fill: "#F9F9FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4f6adcc3509625953ebff9f63872c4d1.svg";
export { ForwardRef as ReactComponent };